import {Component, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Door} from '../../../classes/Door';
import {DoorService} from '../../../services/door.service';

@Component({
  selector: 'app-door-list',
  styleUrls: ['./door-list.component.scss'],
  templateUrl: './door-list.component.html',
})
export class DoorListComponent implements OnInit {

  public doors: Door[];
  public doorForm: FormGroup;
  public editorVisible = false;
  public errorMessage: string;

  constructor(private doorService: DoorService, private formBuilder: FormBuilder) {
    this.doorForm = this.formBuilder.group({
      id: [''],
      name: ['', Validators.required],
    });
  }

  ngOnInit(): void {
    this.updateDoors();
  }

  private updateDoors(): void {
    this.doorService.getAll().subscribe((response: Door[]) => this.doors = response);
  }

  private reset(): void {
    this.editorVisible = false;
    this.errorMessage = undefined;
  }

  public addDoor(): void {
    this.doorForm = this.formBuilder.group({
      name: ['', Validators.required],
    });
    this.editorVisible = true;
  }

  public editDoor(door: Door): void {
    this.doorForm = this.formBuilder.group({
      id: [door.id],
      name: [door.name, Validators.required],
    });
    this.editorVisible = true;
  }

  public saveDoor(): void {
    this.doorService.save(new Door(this.doorForm.value))
      .subscribe({
        next: () => {
          this.updateDoors();
          this.reset();
        },
        error: (error) => this.errorMessage = error.error.error
      });
  }

  public deleteDoor(id: number): void {
    this.doorService.delete(id).subscribe({
      next: () => {
        this.updateDoors();
      },
      error: (error) => this.errorMessage = error.error.error
    });
  }

  // TODO remove it
  public hideEditor(): void {
    this.reset();
  }
}
